export default __webpack_public_path__ + "static/media/by_7.43367cdd.mp3";